var _effectorFileName = "/builds/gmini/front-ui-kit/src/HighlightText/HighlightText.tsx";
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import Highlighter from 'react-highlight-words';
import { jsx as _jsx } from "react/jsx-runtime";
export const HighlightText = ({
  text,
  pattern
}) => {
  const classes = useStyles();
  return /*#__PURE__*/_jsx(Highlighter, {
    highlightClassName: classes.highlight,
    searchWords: [pattern],
    autoEscape: true,
    textToHighlight: text
  });
};
const useStyles = makeStyles(() => createStyles({
  highlight: {
    background: 'rgba(76, 94, 207, 0.2)',
    borderRadius: 0,
    color: 'rgba(53, 59, 96, 1)',
    display: 'inline-block'
  }
}));